import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { graphql, Link, useStaticQuery } from "gatsby"
import { MediaSectionStyles } from "./MediaPostsSection.styles"
import ApButton from "../../Global/Common/ApButton/ApButton"
import { navigateTo } from "../../../utils/hooks"

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const formatPublishedOn = (raw) => {
  if (!raw) return "";
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return raw;
  const day = String(d.getDate()).padStart(2, "0");
  return `${day} ${MONTHS[d.getMonth()]}, ${d.getFullYear()}`;
};

const MediaPostsSection = () => {
  const data = useStaticQuery(graphql`
    {
      statamic {
        entries(
          collection: "blog_posts"
          limit: 4
          sort: ["published_on desc"]
          filter: { blog_categories: { contains: "updates" } }
        ) {
          data {
            id
            slug
            ... on Statamic_Entry_BlogPosts_BlogPost {
              title
              published_on
            }
          }
        }
      }
    }
  `)
  const mediaPosts = data?.statamic?.entries?.data || [];
  return (
    <MediaSectionStyles>
      <Container className="p-5 px-lg-0">
        {mediaPosts.map((mediaPost) => (
          <Row key={mediaPost.id} className="media-post py-3">
            <Col xs={12} lg={3} className="px-lg-0">
              <div className="d-flex primary-blue-text my-2 align-items-top h-100">
                <p>{`${formatPublishedOn(mediaPost.published_on)} . Company Update`}</p>
              </div>
            </Col>
            <Col className="px-lg-0">
              <h5 className="my-2 primary-blue-text media-post-title">{mediaPost.title}</h5>
            </Col>
            <Col xs={12} lg={2} className="px-lg-0">
              <div className="d-flex my-2 align-items-bottom h-100 ">
                <Link
                  className="read-more secondary-blue-2-text mx-3 "
                  to={`/blog/${mediaPost.slug}/`}
                >
                  - Read More
                </Link>
              </div>
            </Col>
          </Row>
        ))}
        <ApButton
          variant="lightBlue"
          className="mt-5 mx-0"
          onClick={(e) => navigateTo(e, "/blog/updates/")}
        >
          View All Press Releases
        </ApButton>
      </Container>
    </MediaSectionStyles>
  )
}

export default MediaPostsSection
